exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".coinDisplay{display:inline-block;line-height:1;border-radius:50px;background:#f3e9b5;padding-right:10px}.coinDisplay img{margin-right:5px}.coinDisplay .coinCount{position:relative;font-weight:700;color:#555}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/coin_display.scss
// module id = 895
// module chunks = 0